<template>
  <div></div>
</template>
<script>
import serviceRegistery from '../../mixins/serviceRegistery'
import { jsonHelper } from '../../mixins/jsonHelper'
import { helpers } from '../../mixins/helpers'
export default {
  created: function() {
    this.getSubrandCreateMetaData()
    this.getSubrandSetupMetaData()
    this.getConfigParams()
    this.getConfigLocale()
    this.getConfigCbdk();
  },
  mixins: [jsonHelper, helpers],
  methods: {
    getConfigParams() {
      var self = this
      serviceRegistery
        .makeCall({
          url:
            this.$hostnameStatic +
            'static/assets/data/default_params_subbrand.json',
          method: 'GET'
        })
        .then(
          response => {
            self.$store.state.createSubbrandStore.params = response.data
          },
          error => {
            console.log('Error in getting static JSON file data', error)
          }
        )
    },
    getConfigLocale() {
      var self = this
      serviceRegistery
        .makeCall({
          url:
            this.$hostnameStatic +
            'static/assets/data/default_strings_subbrand.json',
          method: 'GET'
        })
        .then(
          response => {
            self.$store.state.createSubbrandStore.strings = response.data
          },
          error => {
            console.log('Error in getting static JSON file data', error)
          }
        )
    },

    getConfigCbdk() {
      var self = this
      serviceRegistery
        .makeCall({
          url:
            this.$hostnameStatic +
            'static/assets/data/default_css_data_subbrand.json',
          method: 'GET'
        })
        .then(
          response => {
            self.$store.state.createSubbrandStore.cbdk = response.data
          },
          error => {
            console.log('Error in getting static JSON file data', error)
          }
        )
    },
    
    getSubrandCreateMetaData() {
      // Get Create Sub-brand Meta data.
      serviceRegistery
        .makeCall({
          url:
            this.$hostnameStatic +
            'static/assets/data/subbrand_create_forms.json',
          method: 'GET'
        })
        .then(
          response => {
            this.$store.state.createSubbrandStore.createTemplateData = JSON.parse(
              JSON.stringify(response.data)
            )
            this.$store.state.createSubbrandStore.orgCreateTemplateData = JSON.parse(
              JSON.stringify(response.data)
            )
            console.log(
              'Subbrand Create Meta Data',
              this.$store.state.createSubbrandStore.orgCreateTemplateData
            )
            this.getChannelConfigData()
          },
          error => {
            console.log('Error in getting static JSON file data', error)
          }
        )
    },
    getSubrandSetupMetaData() {
      // Get Create Sub-brand Meta data.
      serviceRegistery
        .makeCall({
          url:
            this.$hostnameStatic +
            'static/assets/data/subbrand_setup_form.json',
          method: 'GET'
        })
        .then(
          response => {
            this.$store.state.createSubbrandStore.setupTemplateData = JSON.parse(
              JSON.stringify(response.data)
            )
            this.$store.state.createSubbrandStore.orgSetupTemplateData = JSON.parse(
              JSON.stringify(response.data)
            )
            console.log(
              'Subbrand Setup Meta Data',
              this.$store.state.createSubbrandStore.orgSetupTemplateData
            )
            this.getChannelConfigData()
          },
          error => {
            console.log('Error in getting static JSON file data', error)
          }
        )
    },
    getChannelConfigData() {
      console.log('GET CHANNEL CONFIG DATA')
      let reqObj = {
        includeConfig: true,
        includeBrand: true
      }
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/channel/get',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          if (response && response.data) {
            let channelConfigData = response.data.config
            console.log(channelConfigData)
            // Convert object data into dot notation data
            let dotNotationData = this.objectToDotNotationJson(
              channelConfigData
            )
            console.log('Dot Notation Data--->', dotNotationData)

            // Add Subbrand Info to dot notation data
            const channelData = Object.assign(
              {},
              dotNotationData,
              channelConfigData
            )

            console.log('Before Mearge--->', channelData)

            // Merge the dot notation data in tempalte data
            let orgTemplateData = JSON.parse(
              JSON.stringify(
                this.$store.state.createSubbrandStore.orgCreateTemplateData
              )
            )
            let mergedData = this.mergeDotNotationInTemlateData(
              channelData,
              orgTemplateData,
              true
            )

            this.$store.state.createSubbrandStore.createTemplateData = JSON.parse(
              JSON.stringify(mergedData)
            )

            this.$store.state.createSubbrandStore.orgCreateTemplateData = JSON.parse(
              JSON.stringify(mergedData)
            )

            console.log('Mearged Data---->', mergedData)
            this.$store.state.createSubbrandStore.channelBrandConfig = response.data.brand;
            this.getChannelConfigDataSuccess()
          } else {
            console.log('GET CHANNEL Error')
          }
        })
    },
    getChannelConfigDataSuccess() {
      this.getSubrandList()
    },
    getSubrandList() {
      // Get Sub-brand list data
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/all',
          method: 'POST',
          data: {
            includeConfig: true,
            configFilterKeys: ['generalConfig.customerType']
          }
        })
        .then(
          response => {
            if (response && response.data && response.data[0]) {
              console.log('SUB-BRAND List --->', response)
              this.$store.state.subbrandListStore.subBrandListData = JSON.parse(
                JSON.stringify(response.data)
              )
              this.$router.push('/list')
            } else {
              console.log('No Sub-bands found')
              this.$router.push('/noSubbrand')
              // No Data
            }
          },
          error => {
            console.log('Network error', error)
          }
        )
    }
  }
}
</script>
